import {TerraUtils} from '../TerraUtils';

export class SearchOptionsRequest {
  orderBy = '';
  sortOrder = 'asc';
  pageNumber = 0;
  filter = '';
  includeRemoved = false;
  pageSize = TerraUtils.consts.DISPLAY_TABLE_PER_PAGE;

  constructor(pageSize: number = null) {
    if (pageSize) {
      this.pageSize = pageSize;
    }
  }
}
